import { z } from 'zod';

export const Language = z.object({
  code: z.string().default(''),
  displayName: z.string().default(''),
});
export type LanguageType = z.infer<typeof Language>;

export const DefinitionItem = z.object({
  languageCode: z.string().default(''),
  displayName: z.string().default(''),
  content: z.string().default(''),
});
export type DefinitionItemType = z.infer<typeof DefinitionItem>;
